<button class="cancel-btn" (click)="buttonClicked()">
  {{ title }}
</button>
